import { render, staticRenderFns } from "./crescimento.vue?vue&type=template&id=425f653b"
import script from "./crescimento.vue?vue&type=script&lang=js"
export * from "./crescimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports